module.exports = __webpack_public_path__ + "07_mole.641c49d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer2/07_mole.png
// module id = h1xG
// module chunks = 0